import React, { useEffect, useState, useRef } from "react";
import Styles from "../../../assets/css/Blogs/RealLifeGadgets/NightSleepMask.module.css";
import { useGlobalState } from "../../../Functions/GlobalStates";
import debounce from "lodash.debounce";
import Loading from "../../Loadings/Loading";
import { Helmet } from "react-helmet-async";

const NightSleepMask = () => {
  // States Here
  const [IsLoaded, setIsLoaded] = useState(false); // I CAN use this to show loading before all images loads
  // Global States Here //////////////////////////////////////////////////////...............................
  const {
    CheckPage,
    setCheckPage,
    DontAllow,
    setDontAllow,
    PagesWidthHeight,
    setPagesWidthHeight,
  } = useGlobalState();

  // React Elements References Here //////////////////////////////////// ...............
  const CheckPageStateRef = useRef(false); // Ref for the check Page
  const NightSleepMaskHeight = useRef(false); // Ref for the absolute box

  const ProductImages = require.context(
    "../../../assets/images/Blogs/RealLifeGadgets/NightSleepMask",
    false,
    /\.(png|jpe?g|gif|bmp|webp|svg|avif)$/
  );
  const ProductImagesArray = [
    ProductImages("./12.avif"),
    ProductImages("./13.avif"),
    ProductImages("./15.avif"),
    ProductImages("./16.avif"),
    ProductImages("./20.avif"),
  ];

  // Show And Hide Navbar DropMenu HomePage
  useEffect(() => {
    const handleCheckResize = () => {
      if (!CheckPageStateRef.current) {
        CheckPageStateRef.current = true;
        setCheckPage(true);
        setDontAllow(true);
      }
      // console.log("oN Mount", CheckPageStateRef.current);
      // console.log("Mounted User Entered");
    };
    handleCheckResize(); // call on mount

    // Add the resize event listener
    window.addEventListener("resize", handleCheckResize);

    // Update global state when the component unmounts , It mean when The user Leaves This Page
    return () => {
      if (CheckPageStateRef.current) {
        CheckPageStateRef.current = false;
        setCheckPage(true);
        setDontAllow(false);
      }
      // console.log("oN unMOUNT", CheckPageStateRef.current);
      // console.log("Unmounted User Leaved");
      window.removeEventListener("resize", handleCheckResize);
    };
  }, []);

  // Preload Images Before render it will help to descrease flickers on img change
  useEffect(() => {
    const preloadImages = async (imageArray, callback) => {
      try {
        await Promise.all(
          imageArray.map((src) => {
            return new Promise((resolve, reject) => {
              const img = new Image();
              img.src = src;
              img.onload = resolve;
              img.onerror = reject; // Add error handling
            });
          })
        );
        callback(); // Callback after all images are preloaded
      } catch (error) {
        console.error("Error preloading image:", error);
      }
    };

    preloadImages([ProductImagesArray[4]], () => {
      setIsLoaded(true); // Set state when all images are loaded
      // console.log("All Images Are Loaded");
    });
  }, []);

  // updating height to modify Navbar DropMenu height
  useEffect(() => {
    const updateSize = () => {
      if (NightSleepMaskHeight.current) {
        const { width, height } =
          NightSleepMaskHeight.current.getBoundingClientRect();
        setPagesWidthHeight((prev) => ({
          ...prev,
          height: parseFloat(height.toFixed(1)),
        }));
      }
    };

    updateSize(); // Run once on mount
    // Debounce Will Help Derease the Consuption of the Ram & Limit Bulk re-Runing Funtions in a Sec
    const updateSizeDelay = debounce(updateSize, 100);
    window.addEventListener("resize", updateSize);
    window.addEventListener("scroll", updateSizeDelay);

    // Cleanup function to remove event listener when component unmounts
    return () => {
      window.removeEventListener("resize", updateSize);
      window.removeEventListener("scroll", updateSizeDelay);
    };
  }, []); // Empty dependency array to run only on mount and unmount

  return IsLoaded ? (
    <>
      <Helmet>
        {/* Page Title */}
        <title>Night Sleep Mask - Healthy Gadget for Better Sleep?</title>

        {/* Meta Description */}
        <meta
          name="description"
          content="Discover the benefits of a night sleep mask – a healthy gadget to improve your sleep quality and help you wake up refreshed."
        />

        {/* Keywords for SEO */}
        <meta
          name="keywords"
          content="Night sleep mask, healthy gadget for sleep, comfortable eye mask, better sleep, real life gadgets"
        />

        {/* Responsive Design */}
        <meta name="viewport" content="width=device-width, initial-scale=1" />

        {/* Open Graph Meta Tags for Social Sharing */}
        <meta
          property="og:title"
          content="Night Sleep Mask - Healthy Gadget for Better Sleep?"
        />
        <meta
          property="og:description"
          content="Discover the benefits of a night sleep mask – a healthy gadget to improve your sleep quality and help you wake up refreshed."
        />
        <meta property="og:type" content="product" />
        <meta
          property="og:url"
          content="https://affiliators.netlify.app/#/reallifegadgets/nightsleepmask"
        />
        {/* <meta property="og:image" content="/images/NightSleepMask/20.jpg" /> */}

        {/* Twitter Meta Tags for Social Sharing */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Night Sleep Mask - Healthy Gadget for Better Sleep?"
        />
        <meta
          name="twitter:description"
          content="Discover the benefits of a night sleep mask – a healthy gadget to improve your sleep quality and help you wake up refreshed."
        />
        {/* <meta name="twitter:image" content="/images/NightSleepMask/20.jpg" /> */}

        {/* Robots Meta Tag */}
        <meta name="robots" content="index, follow" />

        {/* Canonical URL */}
        {/* <link
          rel="canonical"
          href="https://affiliators.netlify.app/#/reallifegadgets/nightsleepmask"
        /> */}

        {/* Additional Meta Tags */}
        <meta name="author" content="Zeeshan Ahmad Kamran" />
        <meta name="language" content="en" />
        <meta http-equiv="Content-Language" content="en" />
      </Helmet>

      <div
        ref={NightSleepMaskHeight}
        className={Styles.NightSleepMaskContainer}
      >
        <section className={Styles.NightSleepMaskSection1}>
          {/* <div className={Styles.NightSleepMaskSection1Text1Container}>
            <h1>Sleep Better with a Night Sleep Mask 😴✨</h1>
          </div> */}
          <img
            src={`${ProductImagesArray[4]}`}
            alt="Night Sleep Mask"
            title="This is an AI-generated representation. Actual product may vary."
          />
          <p>
            These images are AI-generated representations of the products.
            Actual appearance, specifications, features, and colors may vary.
            For the most accurate and up-to-date product details, please refer
            to the official product page via the button at the end of this blog.
          </p>
          <div className={Styles.NightSleepMaskSection1Text2Container}>
            <h1>| Night Sleep Mask |</h1>
            <h1>Why Use a Sleep Mask?</h1>
            <p>
              A sleep mask blocks out light, helping your brain relax and
              signaling that it’s time to sleep. This small but powerful tool
              can improve sleep quality, making you feel more refreshed in the
              morning!
            </p>
          </div>
          <div className={Styles.NightSleepMaskSection1Img2Container}>
            <img
              src={`${ProductImagesArray[0]}`}
              alt="Night Sleep Mask"
              title="This is an AI-generated representation. Actual product may vary."
            />
            <img
              src={`${ProductImagesArray[1]}`}
              alt="Night Sleep Mask"
              title="This is an AI-generated representation. Actual product may vary."
            />
          </div>
          <div className={Styles.NightSleepMaskSection1Text3Container}>
            <h1>Health Benefits of a Sleep Mask 💡</h1>
            <p>
              <span style={{ color: "black" }}>1.&nbsp;</span> Improves Sleep
              Quality – Darkness triggers melatonin production, the hormone
              responsible for deep sleep. This means better rest and more energy
              during the day! ⚡
            </p>
            <p>
              <span style={{ color: "black" }}>2.&nbsp;</span> Reduces Eye
              Strain – Less exposure to artificial light at night can help
              prevent eye fatigue, especially if you use screens before bed.
              📱❌
            </p>
            <p>
              <span style={{ color: "black" }}>3.&nbsp;</span> Promotes
              Relaxation – Blocking distractions helps your mind unwind,
              reducing stress and anxiety for a peaceful slumber. 🌿
            </p>
            <p>
              <span style={{ color: "black" }}>4.&nbsp;</span> Supports Skin
              Health – Many masks are made with soft, breathable fabrics like
              silk, which prevent wrinkles and keep skin hydrated overnight.
              💆‍♀️💖
            </p>
            <p>
              <span style={{ color: "black" }}>5.&nbsp;</span> Aids in Travel
              Sleep – Whether on a plane, train, or hotel room, a sleep mask
              helps you fall asleep faster, even in unfamiliar places. 🏨✈️
            </p>
          </div>
          <div className={Styles.NightSleepMaskSection1Img3Container}>
            <img
              src={`${ProductImagesArray[2]}`}
              alt="Night Sleep Mask"
              title="This is an AI-generated representation. Actual product may vary."
            />
            <img
              src={`${ProductImagesArray[3]}`}
              alt="Night Sleep Mask"
              title="This is an AI-generated representation. Actual product may vary."
            />
          </div>
          <div className={Styles.NightSleepMaskSection1Text4Container}>
            <h1>Choosing the Right Sleep Mask 🎭</h1>
            <p>
              Look for a mask that is: ✅ Soft and Comfortable – Cotton or silk
              is best for sensitive skin. ✅ Adjustable – A perfect fit ensures
              comfort without slipping off. ✅ Breathable – Avoid masks that
              trap heat, especially if you sleep hot.
            </p>
          </div>
          <div className={Styles.FleeceBalaclavaSection1Text5Container}>
            <h4>
              🔔 If you're interested, similar products are available through
              the provided sources.
            </h4>
          </div>
          <a
            title="This link leads to an affiliate product page. We may earn a commission at no extra cost to you."
            href="https://amzn.to/4gEHqrv"
            target="_blank"
            rel="noopener noreferrer"
            className={Styles.NightSleepMaskSection1BtnAmazonAncherContainer}
          >
            <button
              title="This button leads to an affiliate product page. We may earn a commission at no extra cost to you."
              className={Styles.NightSleepMaskSection1BtnAmazon}
            >
              Buy Now on <span>&nbsp;&nbsp;Amazon</span> <span>&nbsp;»</span>
            </button>
          </a>
          <div className={Styles.NightSleepMaskSection1DesclaimerContainer}>
            <h1>Affiliate Disclaimer 💬</h1>
            <p>
              As an Amazon Associate, I earn from qualifying purchases. This
              helps support the blog at no extra cost to you.
            </p>
            <h1>AI-Generated Images Disclaimer</h1>
            <p>
              The product images on this site are AI-generated representations
              created for illustrative purposes only. They may not perfectly
              match the actual product in terms of color, design, or features.
              For accurate details and images, please refer to the official
              product listing on Amazon by clicking the provided links.
            </p>
            <h1>HashTags</h1>
            <p>
              #SleepMask #BetterSleep #DeepSleep #EyeMask #SleepHealth
              #RestfulNight #Relaxation #LightBlocking #HealthySleep
              #ProductsForHealth
            </p>
            <h1>Keywords</h1>
            <p>
              Best night sleep mask for 2025 Lightweight and breathable eye mask
              for better sleep Comfortable sleep mask that blocks out light
              completely Soft and adjustable sleep mask for men and women Deep
              sleep mask for relaxation and stress relief Perfect travel sleep
              mask for flights and naps Eye mask for reducing eye strain and
              improving sleep quality
            </p>
          </div>
        </section>
      </div>
    </>
  ) : (
    <Loading />
  );
};

export default NightSleepMask;
